import {
  AlertTriangle as AlertTriangleIcon,
  CheckCircle as CheckCircleIcon,
  Clock as ClockIcon,
  RefreshCw as RefreshCwIcon,
} from 'react-feather'

import theme from 'theme'

const ACTIVE_STATUS = 'active'
const INACTIVE_STATUS = 'inactive'

const PENDING_PROGRESS_STATUS = 'pending'
const IN_PROGRESS_PROGRESS_STATUS = 'in_progress'
const IN_PROGRESS_PROGRESS_STATUS_PARSED = 'inProgress'
const COMPLETED_PROGRESS_STATUS = 'completed'
const OVERDUE_PROGRESS_STATUS = 'overdue'

const ACTIVE_LABEL = 'Ativo'
const INACTIVE_LABEL = 'Inativo'

const PENDING_LABEL = 'Aguardando Resposta'
const IN_PROGRESS_LABEL = 'Parcialmente Respondido'
const COMPLETED_LABEL = 'Finalizado'
const OVERDUE_LABEL = 'Atrasado'

const ADVISOR_CARD_SUPPLIER = 'advisor-supplier'
const ADVISOR_CARD_CLIENT = 'advisor-client'
const ADVISOR_CARD_SUGGESTED = 'advisor-suggested'
const ADVISOR_CARD_CLOSED = 'closed'

const GENERAL_INFORMATION_VALUE = 'general_information'
const GENERAL_INFORMATION_LABEL = 'Informações Gerais'

const CREATE_ACTION = 'create'
const APPROVE_ACTION = 'approve'
const REFUSE_ACTION = 'refuse'
const INACTIVATE_ACTION = 'inactivate'
const DESTROY_ACTION = 'destroy'

const REFUSED_LOG_TEXT = 'O fornecedor negou o vínculo'
const APPROVED_LOG_TEXT = 'O fornecedor aceitou o vínculo'
const INACTIVE_LOG_TEXT = 'O vínculo foi inativado'

const STATUSES = {
  [ACTIVE_STATUS]: ACTIVE_STATUS,
  [INACTIVE_STATUS]: INACTIVE_STATUS,
}

const STATUSES_LABEL = {
  [ACTIVE_STATUS]: ACTIVE_LABEL,
  [INACTIVE_STATUS]: INACTIVE_LABEL,
}

const PROGRESS_STATUSES_LABEL = {
  [PENDING_PROGRESS_STATUS]: PENDING_LABEL,
  [IN_PROGRESS_PROGRESS_STATUS]: IN_PROGRESS_LABEL,
  [COMPLETED_PROGRESS_STATUS]: COMPLETED_LABEL,
  [OVERDUE_PROGRESS_STATUS]: OVERDUE_LABEL,
}

const PROGRESS_STATUS_COLOR = {
  [PENDING_PROGRESS_STATUS]:
    theme.palette.companySupplier.progressStatus.pending.backgroundColor,
  [IN_PROGRESS_PROGRESS_STATUS]:
    theme.palette.companySupplier.progressStatus.inProgress.backgroundColor,
  [OVERDUE_PROGRESS_STATUS]:
    theme.palette.companySupplier.progressStatus.overdue.backgroundColor,
  [COMPLETED_PROGRESS_STATUS]:
    theme.palette.companySupplier.progressStatus.completed.backgroundColor,
}

const STATUSES_LABEL_LIST = [
  {
    key: ACTIVE_STATUS,
    label: ACTIVE_LABEL,
  },
  {
    key: INACTIVE_STATUS,
    label: INACTIVE_LABEL,
  },
]

const TABS = [
  { value: 'all', label: 'Todos' },
  { value: ACTIVE_STATUS, label: 'Ativos' },
  { value: INACTIVE_STATUS, label: 'Inativos' },
]

const COMPANY_AGENT_TYPES = [
  { id: 'company_controller', name: 'Controlador' },
  { id: 'company_operator', name: 'Operador' },
  { id: 'company_suboperator', name: 'Sub-operador' },
  { id: 'company_co_controller', name: 'Co-controlador' },
]

const UNABLE_STEP = 'UNABLE'
const FIRST_STEP = 'FIRST_STEP'
const QUESTIONNAIRE_STEP = 'QUESTIONNAIRE'

const CREATION_TEXT = `O fornecedor será notificado por e-mail para confirmar que é seu fornecedor e responder aos questionários.

Caso ele não responda esta primeira notificação, serão feitas mais três tentativas a cada sete dias.

Se não houver resposta, avisaremos você por e-mail.
`
const TEXT_MULT_SUPPLIERS = `Os fornecedores cadastrados serão notificados por e-mail para confirmar que é seu fornecedor e responder aos questionários.

Caso eles não respondam esta primeira notificação, serão feitas mais três tentativas a cada sete dias.

Se não houver resposta, avisaremos você por e-mail. Você pode acompanhar as notificações no histórico destes fornecedores.`

const APPROVE_BASE_TEXT =
  'Ao confirmar o vínculo você irá disponibilizar as medidas que são adotadas por sua empresa, de acordo com as respostas dos seus questionários.'

const APPROVE_CLIENT_TEXT =
  'Os RMCs de questionários finalizados vão ser exibidos como medidas adotadas. Por isso, lembre-se de revisar os seus RMCs de questionários e atualizá-los de acordo com a realidade da sua empresa.'

const PROGRESS_STATS_CARD_ITEMS = [
  {
    status: PENDING_PROGRESS_STATUS,
    subTitle: PENDING_LABEL,
    Icon: ClockIcon,
    iconBgColor: theme.palette.companySupplier.progressStatus.pending.color,
  },
  {
    status: IN_PROGRESS_PROGRESS_STATUS,
    statsKey: IN_PROGRESS_PROGRESS_STATUS_PARSED,
    subTitle: IN_PROGRESS_LABEL,
    Icon: RefreshCwIcon,
    iconBgColor: theme.palette.companySupplier.progressStatus.inProgress.color,
  },
  {
    status: OVERDUE_PROGRESS_STATUS,
    subTitle: OVERDUE_LABEL,
    Icon: AlertTriangleIcon,
    iconBgColor: theme.palette.companySupplier.progressStatus.overdue.color,
  },
  {
    status: COMPLETED_PROGRESS_STATUS,
    subTitle: COMPLETED_LABEL,
    Icon: CheckCircleIcon,
    iconBgColor: theme.palette.companySupplier.progressStatus.completed.color,
  },
]

const MY_SUPPLIERS_MAIN_DRIVER_STEP_1 = 'my-suppliers-main-driver-step-1'
const MY_SUPPLIERS_MAIN_DRIVER_STEP_2 = 'my-suppliers-main-driver-step-2'
const MY_SUPPLIERS_MAIN_DRIVER_STEP_3 = 'my-suppliers-main-driver-step-3'

const MY_SUPPLIERS_DRIVER_STEPS_OBJECT = [
  {
    element: '#' + MY_SUPPLIERS_MAIN_DRIVER_STEP_1,
    popover: {
      description:
        'Um fornecedor, segundo a LGPD, é qualquer entidade com quem você compartilha dados. Você e o fornecedor têm responsabilidade solidária pela proteção dos dados. Garantir a conformidade dos fornecedores com a LGPD é essencial para evitar violações. Através desta função, você pode cadastrar, monitorar e garantir a conformidade dos fornecedores, protegendo as informações da empresa.',
    },
  },
  {
    element: '#' + MY_SUPPLIERS_MAIN_DRIVER_STEP_2,
    popover: {
      description:
        'Importe fornecedores utilizando nossa planilha modelo, disponível para download ao clicar no botão. Você pode incluir fornecedores internacionais, mas lembre-se de cadastrá-los separadamente dos nacionais.',
    },
  },
  {
    element: '#' + MY_SUPPLIERS_MAIN_DRIVER_STEP_3,
    popover: {
      description:
        'Para cadastrar um novo fornecedor, preencha o nome, documento e e-mail de um responsável, e selecione uma data de disparo (o e-mail será enviado durante 5 semanas consecutivas). Além disso, há a opção de cadastrar fornecedores internacionais.',
    },
  },
]

const SUPPLIERS_MAIN_DRIVER_STEP_1 = 'faqs_documentarion-main-driver-step-1'

const SUPPLIERS_DRIVER_STEPS_OBJECT = [
  {
    element: '#' + SUPPLIERS_MAIN_DRIVER_STEP_1,
    popover: {
      description:
        'Esta funcionalidade permite que você visualize e aprove os vínculos com as empresas que o indicaram como fornecedor. Como fornecedor, você pode oferecer serviços, produtos ou atuar como terceirizado em diversas atividades.',
    },
  },
]

const SUPPLIERS_SUGGESTIONS_MAIN_DRIVER_STEP_1 =
  'faqs_documentarion-main-driver-step-1'
const SUPPLIERS_SUGGESTIONS_MAIN_DRIVER_STEP_2 =
  'faqs_documentarion-main-driver-step-2'

const SUPPLIERS_SUGGESTIONS_DRIVER_STEPS_OBJECT = [
  {
    element: '#' + SUPPLIERS_SUGGESTIONS_MAIN_DRIVER_STEP_1,
    popover: {
      description:
        'Quando uma organização é cadastrada como agente de tratamento, ela aparece como uma sugestão de fornecedor.',
    },
  },
  {
    element: '#' + SUPPLIERS_SUGGESTIONS_MAIN_DRIVER_STEP_2,
    popover: {
      description:
        'Você pode aceitar ou recusar a solicitação. Se aceitar, um e-mail será enviado ao fornecedor e ele será adicionado à sua lista de fornecedores. Se recusar, o status será alterado para "Recusado".',
    },
  },
]

const companySuppliers = {
  ACTIVE_STATUS,
  ADVISOR_CARD_CLIENT,
  ADVISOR_CARD_CLOSED,
  ADVISOR_CARD_SUGGESTED,
  ADVISOR_CARD_SUPPLIER,
  APPROVE_ACTION,
  APPROVE_BASE_TEXT,
  APPROVE_CLIENT_TEXT,
  APPROVED_LOG_TEXT,
  COMPANY_AGENT_TYPES,
  COMPLETED_PROGRESS_STATUS,
  CREATE_ACTION,
  CREATION_TEXT,
  DESTROY_ACTION,
  FIRST_STEP,
  GENERAL_INFORMATION_LABEL,
  GENERAL_INFORMATION_VALUE,
  IN_PROGRESS_PROGRESS_STATUS,
  INACTIVATE_ACTION,
  INACTIVE_LABEL,
  INACTIVE_LOG_TEXT,
  INACTIVE_STATUS,
  MY_SUPPLIERS_DRIVER_STEPS_OBJECT,
  MY_SUPPLIERS_MAIN_DRIVER_STEP_1,
  MY_SUPPLIERS_MAIN_DRIVER_STEP_2,
  MY_SUPPLIERS_MAIN_DRIVER_STEP_3,
  OVERDUE_PROGRESS_STATUS,
  PENDING_PROGRESS_STATUS,
  PROGRESS_STATS_CARD_ITEMS,
  PROGRESS_STATUS_COLOR,
  PROGRESS_STATUSES_LABEL,
  QUESTIONNAIRE_STEP,
  REFUSE_ACTION,
  REFUSED_LOG_TEXT,
  STATUSES_LABEL_LIST,
  STATUSES_LABEL,
  STATUSES,
  SUPPLIERS_DRIVER_STEPS_OBJECT,
  SUPPLIERS_MAIN_DRIVER_STEP_1,
  SUPPLIERS_SUGGESTIONS_DRIVER_STEPS_OBJECT,
  SUPPLIERS_SUGGESTIONS_MAIN_DRIVER_STEP_1,
  SUPPLIERS_SUGGESTIONS_MAIN_DRIVER_STEP_2,
  TABS,
  TEXT_MULT_SUPPLIERS,
  UNABLE_STEP,
}

export default companySuppliers
